import request from "../util/SuperagentUtils";
import {getErrorMessageForNonStandardAndStandardResponse} from "../util/NetworkErrorUtil";
import type {SuperAgentRequest} from "superagent";
import {SnackbarShowMessage} from "../context/snackbar-context";
import {optionsEndpoints} from "./api-endpoints";

const getAdminInvoiceGroupSummaryOptions: () => SuperAgentRequest = () => {
  return request.get(optionsEndpoints.general.invoicesGroupSummary);
};

const getAssetTypes: () => SuperAgentRequest = () => {
  return request.get(optionsEndpoints.general.assets);
}

const getTaxStatusTypes: () => SuperAgentRequest = () => {
  return request.get(optionsEndpoints.general.taxStatus);
}

const getAssetTypeGroupOptionsTypes: () => SuperAgentRequest = () => {
  return request.get(optionsEndpoints.general.assetTypeGroup);
}

const getBookingReasonDeclinedOptions: () => SuperAgentRequest = () => {
  return request.get(optionsEndpoints.general.bookingReasonDeclined);
}

const getFormattedEquipmentTypes = (snackbarShowMessage: SnackbarShowMessage) => {

  const newEquipment = [{value: 'ALL', label: 'All'}];

  getAssetTypes()
      .then(({body}) => {
          body.forEach((equipment: { key: string; value: string; }) => {
              newEquipment.push({value: equipment.key, label: equipment.value})
          })
      }).catch(err => {
          snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(err), 'error')
      })

  return newEquipment;
}

export {
  getAdminInvoiceGroupSummaryOptions,
  getAssetTypes,
  getTaxStatusTypes,
  getAssetTypeGroupOptionsTypes,
  getFormattedEquipmentTypes,
  getBookingReasonDeclinedOptions
}
